const state = {
  armory: {
    // lists the profiles handled by the app.
    profiles: null,

    // this is the profile currently selected
    selectedProfileID: null,
    selectedProfile: null,
    selectedProfileHistory: null,

    // this is the list of heroes selected either when a profile
    // is selected or because a query retruned only a list of heroes.
    heroes: [],

    // this is the hero surrently selected.
    selectedHeroID: null,
    selectedHero: null
  }
}

const getters = {
  // global armory object
  armory: state => {
    return state.armory
  },

  // Profiles
  armoryProfiles: state => {
    return state.armory.profiles
  },

  // Selected profile
  armorySelectedProfile: state => {
    return state.armory.selectedProfile
  },
  armorySelectedProfileID: state => {
    return state.armory.selectedProfileID
  },
  armorySelectedProfileHistory: state => {
    return state.armory.selectedProfileHistory
  },

  // Heroes
  armoryHeroes: state => {
    return state.armory.heroes
  }
}

const mutations = {
  // Profiles
  setProfiles: (state, payload) => {
    state.armory.profiles = payload
  },

  // Selected profiles
  setSelectedProfileID: (state, payload) => {
    state.armory.selectedProfileID = parseInt(payload)
  },
  setSelectedProfile: (state, payload) => {
    state.armory.selectedProfile = payload
  },
  setSelectedHeroesForProfile: (state, payload) => {
    state.armory.heroes = payload
  },
  setSelectedProfileHistory: (state, payload) => {
    state.armory.selectedProfileHistory = payload
  }
}

const actions = {

}

export default {
  state,
  getters,
  mutations,
  actions
}
